import { createSelector } from '@reduxjs/toolkit';
import { ObjectOfAny } from '../reducers/types';
import { RootState } from '../store/store';

let SurveyProjections = {} as ObjectOfAny;

SurveyProjections.surveyData = createSelector(
    (state: RootState) => state.survey.surveyType,
    (state: RootState) => state.survey.posting,
    (state: RootState) => state.survey.postingSuccessBody,
    (state: RootState) => state.survey.loading,
    (state: RootState) => state.survey.errorMessage,
    (surveyTypes, posting, postingSuccessBody, loading, errorMessage) => {
        return {
            surveyTypes: surveyTypes ? surveyTypes : [],
            posting,
            postingSuccessBody,
            loading,
            isCompleted: postingSuccessBody ? postingSuccessBody.title : null,
            errorMessage: errorMessage,
        };
    },
);

export default SurveyProjections;
